export type t_parameter_value = null | number | boolean | string;
export type TParameters = Record<string, t_parameter_value | t_parameter_value[]>;

export type t_locator_fields =
  | 'href'
  | 'host'
  | 'hostname'
  | 'href'
  | 'pathname'
  | 'port'
  | 'protocol'
  | 'search'
  | 'origin'
  | 'hash';
export type TLocationFields = Pick<Location, t_locator_fields>;
export type TConstants = Record<string, unknown>;

export const regExp = {
  manySlashes: /\/\/+/g,
  fixSingleQuotes: /'/g,
  routeParameters: /:([a-z_][a-z0-9-_]*)/gi,
  matchQueryParameters: /\?.*?$/,
  matchFirstSlash: /^\//,
  // @note used to erase all variable permutations from the string
  matchWholeWords: /^[\w_]+$/i
};
